var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookOpen = function SvgBookOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.75 17.25v1.5h-1.5v-1.5h-6a.75.75 0 0 1-.75-.75v-12a.75.75 0 0 1 .75-.75h4.5A3 3 0 0 1 10 4.766a3 3 0 0 1 2.25-1.016h4.5a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75zm5.25-1.5V5.25h-3.75a1.5 1.5 0 0 0-1.5 1.5v9zm-6.75 0v-9a1.5 1.5 0 0 0-1.5-1.5H4v10.5z"
  })));
};
export default SvgBookOpen;